import { Page, usePlatformTheme } from '@ui/themed';
import type { PropsWithChildren } from 'react';
import { AdditionalHelpCard } from '../components/additional-help-card';
import { DataSyncCards } from '../components/data-sync-cards';
import { SalesPerformanceCard } from '../components/sales-performance-card';

export function PostLaunchPage({ children }: PropsWithChildren) {
  const theme = usePlatformTheme();
  return (
    <Page>
      {children}
      <SalesPerformanceCard />
      {/*  Remove direct links into the dashboard from Shopify on primary workflows */}
      {theme !== 'polaris' && <DataSyncCards />}
      <AdditionalHelpCard />
    </Page>
  );
}
